import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useGuestsContext } from 'hb-react/shared/apps/Events/contexts/GuestsContext';
import { useGuestOptions } from 'hb-react/shared/apps/Events/hooks';
import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import { useForm } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/hooks/useForm';
import { useGuestUpdate } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/hooks/useGuestUpdate';

import { GuestsTicketForm } from './components/FOForm';
import { TicketForm } from './components/POForm';

const EventTickets = ({ currentUser, attendeesAttributes }) => {
  const { guests, actions } = useGuestsContext();

  const guestsOptions = useGuestOptions({ guests, currentUser });

  useGuestUpdate({
    guests,
    attendeesAttributes,
  });

  return attendeesAttributes.map((attendee, index) => (
    <GuestsTicketForm
      attendee={attendee}
      currentUser={currentUser}
      guestsOptions={guestsOptions}
      ticket={attendee.ticket}
      index={index}
      key={`${index}:${attendee.id}`}
      updateGuest={actions.update}
      createGuest={actions.create}
      deleteGuest={actions.delete}
    />
  ));
};

const EventTicketsPo = ({ attendeesAttributes }) => {
  const { event } = useBooking();

  return attendeesAttributes.map((attendee, index) => (
    <TicketForm
      attendee={attendee}
      standardFields={event?.standard_fields}
      ticket={attendee.ticket}
      index={index}
      key={`${index}:${attendee.id}`}
    />
  ));
};

export const Form = () => {
  const { currentUser } = useDefaultAppContexts();

  const {
    values: { attendees },
  } = useForm();

  return currentUser ? (
    <EventTickets currentUser={currentUser} attendeesAttributes={attendees} />
  ) : (
    <EventTicketsPo attendeesAttributes={attendees} />
  );
};
